export default __webpack_public_path__ + "static/media/bg-cny-campaign.ed174cff.png";